import { memo } from 'react';

import Notifier from './Notifier';

export default memo(Notifier);
